// extracted by mini-css-extract-plugin
export default {"root":"style_root__n6j6z","resultBlur":"style_resultBlur__OX5xT"};